import "./Sessions.css";
import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { Outlet, Link } from "react-router-dom";
import { connect } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import Footer from "../Footer/Footer";

import logo from "../../../../src/logo.svg";
import EnIcon from '../../../libraries/Icons/en.png';
import ViIcon from '../../../libraries/Icons/vi.png';
import JaIcon from '../../../libraries/Icons/ja.png';

const Sessions = (props) => {
  const { translate, UserInfor, Intl } = props;
  const pages = [
    // {
    //   name: translate('feature'),
    //   to: '/feature'
    // }, 
    // {
    //   name: translate('pricing'),
    //   to: '/pricing'
    // },
  ];
  const authentications = [
    // {
    //   name: translate('signin'),
    //   to: '/signin',
    //   variant: "contained",
    //   color:"primary"
    // },
    // {
    //   name: translate('tryforfree'),
    //   to: '/register/standard',
    //   variant: "outlined",
    //   color:"success"
    // }
  ];
  const langs = [
    {
      locale: 'en'
      , src: EnIcon
      , value: 'English'
    },
    {
      locale: 'vi'
      , src: ViIcon
      , value: 'Tiếng Việt'
    },
    {
      locale: 'ja'
      , src: JaIcon
      , value: '日本語'
    },
  ]
  
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [openMobileMenu, setOpenMobileMenu] = React.useState(false);
  const [openChangeLanguage, setOpenChangeLanguage] = React.useState(false);
  const [anchorElChangeLanguage, setAnchorElChangeLanguage] = React.useState(null);

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleCloseNavMenu = (e) => {
    setAnchorElNav(null);
  };

  const handleOpenMobileMenu = () => {
    setOpenMobileMenu(true);
  };

  const handleCloseMobileMenu = () => {
    setOpenMobileMenu(false);
  };

  const handleChangeLanguage = (event) => { 
    setOpenMobileMenu(false);
    setOpenChangeLanguage(true);
    setAnchorElChangeLanguage(event.currentTarget);
  }

  const handleCloseChangeLanguage = () => {
    setOpenChangeLanguage(false);
    setAnchorElChangeLanguage(null);
  };

  const handleSubmitChangeLanguage = (locale) => {
    localStorage.setItem('_locale', locale);
    props.dispatch({ type: 'UPDATE_INTL', Intl: {locale} });
  }

  return (
    <React.Fragment>
      <Box className="sessions">
        <AppBar position="fixed" className="menu">  
          <Container maxWidth="100%">
            <Toolbar disableGutters sx={{ gap: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                <Box component={Link} to="/signin" sx={{ mr: 1 }}>
                  <img alt="logo" src={logo} width={50} />
                </Box>
                <Typography
                  variant="h6"
                  noWrap
                  component={Link}
                  to="/signin"
                  color="primary"
                  sx={{
                    mr: 2,
                    fontWeight: 700,
                    textDecoration: 'none',
                  }}
                >
                  RPA CLOUD
                </Typography>
              </Box>
              <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' }, gap: 2 }}>
                {pages.map((page, index) => (
                  <Button
                    component={Link}
                    key={page.name}
                    to={page.to}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: '#4B5563', display: 'block' }}
                  >
                    {page.name}
                  </Button>
                ))}
                {/* <Button
                    component="a"
                    target="_blank"
                    href="https://blog.rpa-cloud.io"
                    sx={{ my: 2, color: '#4B5563', display: 'block' }}
                  >
                    {translate('blog')}
                </Button> */}
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Tooltip arrow title={translate('changelanguage')}>
                    <IconButton size="small" onClick={handleChangeLanguage}>
                      <img height="24px" src={langs.find(lang => lang.locale === Intl.locale)?.src} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
              <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' }, gap: 1 }}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  {authentications.map(item => (
                     <Button 
                      component={Link} 
                      variant={item.variant}
                      to={item.to}
                      color={item.color}
                      disableElevation 
                      endIcon={<ChevronRightIcon />} 
                    >
                     {item.name}
                      </Button>
                  ))}
                </Box>
              </Box>
              {/* For mobile */}
              <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' }, alignItems: "center", justifyContent: "right" }}>
                <Box sx={{ gap: 1, display: "flex", alignItems: "center", mr: 2 }}>
                  <Tooltip arrow title={translate('changelanguage')}>
                    <IconButton size="small" onClick={handleChangeLanguage}>
                      <img height="24px" src={langs.find(lang => lang.locale === Intl.locale)?.src} />
                    </IconButton>
                  </Tooltip>
                </Box>
                {/* <Button
                  className="icon-button"
                  onClick={handleOpenMobileMenu}
                  variant="outlined"
                  sx={{ minWidth: 40 }}
                >
                  <MenuIcon size="small" color="primary" />
                </Button> */}
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
        <Outlet />
        <Footer />
      </Box>
      <Popover
        open={openChangeLanguage}
        anchorEl={anchorElChangeLanguage}
        onClose={handleCloseChangeLanguage}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        disableScrollLock={true}
      >
        <Box p={1}>
          <List dense>
            {langs.map((lang) => 
            (<ListItem 
              button
              key={lang.locale}
              selected={Intl.locale === lang.locale} 
              onClick={() => { handleSubmitChangeLanguage(lang.locale) }}
            >
              <ListItemIcon className='iconChangeLanguage'>
                <img
                  height="24px"
                  src={lang.src}
                />
              </ListItemIcon>
              <ListItemText primary={lang.value} className='textChangeLanguage' />
            </ListItem>))}
          </List>
        </Box>
      </Popover>
      {/* <Dialog
        fullScreen
        open={openMobileMenu}
        onClose={handleCloseMobileMenu}
        TransitionComponent={Transition}
        disableScrollLock={true}
        sx={{ position: openMobileMenu ? 'fixed' : 'inherit' }}
      >
        <Container>
          <Box sx={{ mt: 1, display: "flex", justifyContent: "right" }}>
            <Button
              className="icon-button"
              onClick={handleCloseMobileMenu}
              variant="outlined"
              sx={{ minWidth: 40 }}
            >
              <CloseIcon size="small" color="primary" />
            </Button>
          </Box>
          <Box>
            {pages.map((page, index) => (
              <Button
                component={Link}
                key={page.name}
                to={page.to}
                onClick={handleCloseMobileMenu}
                sx={{ my: 1, color: 'primary.main', display: 'block', textAlign: "left" }}
              >
                {page.name}
              </Button>
            ))}
            <Button
                component="a"
                target="_blank"
                href=""
                sx={{ my: 1, color: 'primary.main', display: 'block', textAlign: "left" }}
              >
                {translate('blog')}
            </Button>
            {authentications.map(item => (
            <Box sx={{ mb: 2, display: "flex", justifyContent: "left" }}>
              <Button 
                component={Link} 
                variant={item.variant}
                to={item.to}
                color={item.color}
                disableElevation 
                endIcon={<ChevronRightIcon />} 
                onClick={handleCloseMobileMenu}
              >
                {item.name}
              </Button>
            </Box>
            ))}
          </Box>
        </Container>
      </Dialog> */}
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    UserInfor: state.UserInfor,
    Intl: state.Intl,
  }
}

export default connect(mapStateToProps)(withTranslate(Sessions));